import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const siteSupportRoutes = {
  [ERouteMappingKeys.SITE_SUPPORT]: {
    id: "site-support",
    path: "/site-support",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/SiteSupport").then((p) => ({
          default: p.SiteSupport,
        })),
      ),
    },
  },
};
